import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { NavIcon } from '../nav-icon/nav-icon';

/**
 * Компонент управления в шапке сайдбара: свернуть/развернуть меню,
 * сведения о пользователе и выход из приложения.
 */
@Component({
    selector: 'app-shell-controls',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatTooltip, NavIcon],
    templateUrl: './shell-controls.html',
    styleUrl: './shell-controls.scss',
})
export class ShellControls {
    /** Сайдбар свёрнут в рейл: пользователь остаётся только в подсказке. */
    readonly collapsed = input(false);
    readonly userName = input.required<string>();
    readonly roleName = input<string | null>(null);

    readonly navToggled = output<void>();
    readonly logoutRequested = output<void>();

    protected readonly userHint = computed(() => {
        const role = this.roleName();
        return role ? `${this.userName()} — ${role}` : this.userName();
    });
}
